import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { SUPPORTED_LANGUAGES } from './constants'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh-CN',
    lng: 'zh-CN',
    // 支持的语言（包含备用语言代码）
    supportedLngs: ['zh-CN', 'zh', 'en-US', 'en', 'pt-BR', 'pt'],
    nonExplicitSupportedLngs: true, // 允许非精确匹配
    load: 'currentOnly', // 只加载当前语言，减少初始资源加载
    cleanCode: false, // 不清理语言代码
    lowerCaseLng: false, // 保持大小写

    // 命名空间配置 - 6个命名空间按需加载
    ns: ['common', 'pages', 'modules', 'components', 'errors', 'validation'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already escapes
      prefix: '{',        // 使用单花括号作为插值前缀
      suffix: '}',        // 使用单花括号作为插值后缀
    },

    // 键分隔符配置 - 使用扁平JSON结构，禁用键分隔符
    keySeparator: false,  // 禁用键分隔符，匹配扁平JSON格式
    nsSeparator: ':',   // 命名空间使用冒号分隔，如 "pages:login.title"

    backend: {
      // 使用自定义加载路径，将简化的语言代码映射到完整代码
      loadPath: (lngs: string[], namespaces: string[]) => {
        const lng = lngs[0]
        const ns = namespaces[0]
        // 语言代码映射
        const langMap: Record<string, string> = {
          'zh': 'zh-CN',
          'zh-CN': 'zh-CN',
          'en': 'en-US',
          'en-US': 'en-US',
          'pt': 'pt-BR',
          'pt-BR': 'pt-BR'
        }
        const mappedLang = langMap[lng] || lng
        return `/locales/${mappedLang}/${ns}.json`
      },
    },

    react: {
      useSuspense: false,
    },

    debug: false,

    // 开发模式下的额外配置
    updateMissing: false,
    saveMissing: false,

    // 禁用部分缓存
    partialBundledLanguages: true,
  })

export default i18n